import { ChangeDetectionStrategy, Component, computed, effect, inject, model, signal } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { NotificationsService } from './notifications.service';
import { ModalHeaderComponent, ModalComponent, ModalComponents } from 'ets-fe-ng-sdk';
import { NotificationService as MessageService } from './notification.service';
import { INotificationReceiver } from './notification.model';
import { BtnComponent, LoaderComponent, TrimTextPipe } from 'ets-fe-ng-sdk';
import { UtilityService } from '../../services/utility.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateNoLoaderPipe } from '@evolutics/translation';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { NotificationHistoryComponent } from './notification-history/notification-history.component';
import { NotificationHandlerService } from './notification-handler.service';

@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  imports: [
    ModalHeaderComponent,
    MatDialogModule,
    BtnComponent,
    MatSlideToggleModule,
    LoaderComponent,
    TranslateNoLoaderPipe,
    AsyncPipe,
    FormsModule,
    TrimTextPipe,
    ModalComponents,
    NgClass,
    DatePipe,
    NotificationHistoryComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent {
  readonly notificationHandlerService = inject(NotificationHandlerService);
  readonly selectedNotification = signal<INotificationReceiver | null>(null);
  readonly notifications = computed(() => this.nS.notifications());
  readonly notificationGroups = computed(() => this.nS.notificationGroups());
  readonly loading = computed(() => this.nS.loading() && !this.notifications()?.length);
  readonly loadingCanLoadMore = computed(() => this.nS.loading());
  readonly canLoadMore = computed(() => this.nS.canLoadMore());
  readonly showOnlyUnread = model(true);
  readonly expandedMap = signal<{ [id: string]: boolean }>({});

  constructor(
    public nS: NotificationsService,
    public dialogRef: MatDialogRef<NotificationsComponent>,
    public mS: MessageService,
    public uS: UtilityService,
    public router: Router,
    public route: ActivatedRoute,
  ) {
    effect(() => console.log('expandedMap', this.expandedMap()));
  }

  ngOnInit(): void {
    if (!this.nS.loadedNotifications())
      try {
        this.loadMore();
      } catch (error) {}
  }

  async loadMore() {
    try {
      await this.nS.loadMore();
    } catch (error) {
      // debugger;
      this.uS.info(error, 0);
    }
  }

  toggleExpanded(id: string) {
    this.expandedMap.update((mp) => ({ ...mp, [id]: !mp[id] }));
  }

  async toggleShowOnlyUnread(showRead: boolean) {
    try {
      await this.nS.toggleShowOnlyUnread(showRead);
    } catch (error) {
      this.uS.info(error, 0);
    }
  }
}
